import { Text } from '@intellecteu/common-ui';
import { useUTCDate } from 'app/utils/hooks';

interface PruneUtcDateTooltipProps {
  entity?: string;
}

export const PruneUtcDateTooltip = ({ entity = 'pruning' }: PruneUtcDateTooltipProps) => {
  const utcDate = useUTCDate();

  return <Text>{`Server time is used to schedule ${entity}: ${utcDate}`}</Text>;
};
